import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { ApiError } from 'src/types/interfaces/api-error';

import { resetPassword } from '../../api/lib/auth';

import { OrganizationLanguage } from '@/features/settings/api/types/gdpr';

export const useSendResetPasswordLink = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: ({ email, language }: { email: string; language: OrganizationLanguage }) =>
      resetPassword(email, language),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
